// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_t9Q","cls2":"UserTooltip-cls2_EcS UserTooltip-cls1_t9Q"};